// Unified top bar shared across the main tab screens (Discover, Chats,
// Library). Shows the HanZi World wordmark with a Beta badge on the left and
// an optional context slot on the right (typically the account/gear menu).
//
// Chat and Flashcards intentionally render without this header.

import type { ReactNode } from 'react';
import { C } from '@/styles/tokens';

interface AppHeaderProps {
  /** Optional right-aligned content (gear menu, action button, etc.). */
  right?: ReactNode;
}

export function AppHeader({ right }: AppHeaderProps) {
  return (
    <header
      className="px-4 pt-5 pb-3 flex items-center justify-between gap-2 safe-top"
      style={{ background: 'transparent' }}
    >
      <div className="flex items-center gap-2 min-w-0">
        <span
          aria-label="HanZi World"
          className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{
            background: C.vermillion,
            boxShadow: '0 2px 6px rgba(233,75,60,0.32)',
          }}
        >
          <span aria-hidden className="ff-zh-serif text-white text-lg font-bold leading-none">字</span>
        </span>
        <span
          className="ff-display italic text-2xl leading-none whitespace-nowrap"
          style={{ color: C.ink }}
        >
          HanZi World
        </span>
        <span
          className="ff-body text-[9px] font-bold uppercase tracking-[0.15em] px-1.5 py-1 rounded-full leading-none flex-shrink-0"
          style={{ background: C.blush, color: C.vermillionDeep }}
          aria-label="Beta release"
        >
          Beta
        </span>
      </div>
      {right && <div className="flex-shrink-0">{right}</div>}
    </header>
  );
}
